<template>
  <div class="form-group kt-form kt-form--label-right mb-1">
    <div class="row mb-0">
      <div class="col col-md-3 col-12 validated" v-if="formats">
        <BaseRadioButtonGroup
          label="Format"
          :options="formats"
          :disabled="isSearching || isLoading"
          :isMandatory="true"
          v-model="$v.format.$model"
          @blur="$v.format.$touch()"
          :validator="$v.format" />
        <template v-if="$v.format.$error">
          <div class="invalid-feedback" v-if="!$v.format.required">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />
            Format is required.
          </div>
        </template>
      </div>
      <div class="col col-md-3 col-12 validated" v-if="brands">
        <BaseSelect
          label="Brand"
          :options="brands"
          :disabled="isSearching || isLoading"
          :isMandatory="true"
          v-model="$v.brand.$model"
          @blur="$v.brand.$touch()"
          :validator="$v.brand" />
        <template v-if="$v.brand.$error">
          <div class="invalid-feedback" v-if="!$v.brand.required">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />
            Brand is required.
          </div>
        </template>
      </div>
      <div class="col col-md-3 col-12" v-if="themes">
        <BaseSelect
          label="Theme"
          :options="themes"
          :disabled="isSearching || isLoading"
          :isMandatory="false"
          v-model="$v.theme.$model"
          @blur="$v.theme.$touch()"
          :validator="$v.theme" />
      </div>
      <div class="col col-md-3 col-12 validated">
        <BaseInputForm
          ref="searchInput"
          type="text"
          label="Keyword"
          placeholder="Ex. Munich to Vienna"
          :disabled="isLoading"
          :isMandatory="true"
          @keyup.enter="onSearch"
          v-model="$v.keyword.$model"
          @blur="$v.keyword.$touch()"
          :validator="$v.keyword" />
        <template v-if="$v.keyword.$error">
          <div class="invalid-feedback" v-if="!$v.keyword.required">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />
            Keyword is required.
          </div>
          <div class="invalid-feedback" v-if="!$v.keyword.minLength">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />
            Keyword must have at least {{$v.keyword.$params.minLength.min}} letters.
          </div>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import debounce from 'lodash.debounce'

export default {
  name: 'SearchForm',
  data () {
    return {
      format: '',
      brand: '',
      theme: '',
      keyword: ''
    }
  },
  validations: {
    format: { required },
    brand: { required },
    theme: {},
    keyword: { required, minLength: minLength(4) }
  },
  props: {
    formats: {
      type: Array,
      require: true
    },
    brands: {
      type: Array,
      require: true
    },
    themes: {
      type: Array,
      require: true
    },
    isSearching: {
      type: Boolean,
      required: false
    },
    isLoading: {
      type: Boolean,
      required: false
    },
    brandSelected: {
      type: String,
      require: false
    },
    defaultParams: {
      type: Object,
      required: false
    }
  },
  watch: {
    format (newValue, oldValue) {
      this.onReset()
      this.watchHandler(newValue, oldValue)
    },
    brand (newValue, oldValue) {
      this.watchHandler(newValue, oldValue)
    },
    theme (newValue, oldValue) {
      this.watchHandler(newValue, oldValue)
    },
    keyword (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.debouncedSearch()
      }
    }
  },
  created () {
    this.debouncedSearch = debounce(this.onSearch, 500)
    if (this.brandSelected) {
      this.brand = this.brandSelected
    }
    if (this.defaultParams) {
      this.format = this.defaultParams.format
      this.brand = this.defaultParams.brand
      this.theme = this.defaultParams.theme
      this.keyword = this.defaultParams.query
    }
  },
  methods: {
    setInputFocus () {
      this.$nextTick(() => {
        this
          .$refs.searchInput
          .$refs.baseInputForm
          .focus()
      })
    },
    watchHandler (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onSearch()
        this.setInputFocus()
      }
    },
    onSearch () {
      if (this.isLoading) return false
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const params = {
          format: Number(this.format),
          brand: Number(this.brand),
          theme: Number(this.theme),
          query: this.keyword,
          limit: 20,
          offset: 0
        }
        this.$emit('onSearch', params)
      }
    },
    onReset () {
      this.$emit('onReset')
    }
  }
}
</script>
